// import { io } from "socket.io-client";

// const socket = io("http://localhost:3100", {
//   autoConnect: true,
// });

// export default socket;


import { io } from "socket.io-client";
import { ENV_CONFIG } from "../environment/environment-config";
const socket = io(ENV_CONFIG.local.api_url, {
  autoConnect: true,
});

export default socket;
